'use client'

import themeVariables from "@/config/theme/themeVariable";
import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { EyesLinesModal } from "./eyesLinesModal";

interface EyesModalProps {
  forceOpened?: boolean;
  onClose?: () => void;
}

export const EyesModal = ({ forceOpened = false, onClose }: EyesModalProps) => {
  const [opened, { open, close }] = useDisclosure(forceOpened);
  const searchParams = useSearchParams();
  const router = useRouter();
  
  const [showLinesModal, setShowLinesModal] = useState(false);
  
  useEffect(() => {
    if ((searchParams?.get('modal') === 'eyes' || forceOpened) && !showLinesModal) {
      open();
    }
    if (showLinesModal) {
      close();
    }
  }, [searchParams, open, forceOpened, showLinesModal, close]);

  interface ModalItem {
    id: string;
    label: string;
    path?: string;
    action?: () => void;
  }
  
  const items: ModalItem[] = [
    { 
      id: 'method', 
      label: '수술 방법', 
      path: '/eyes/method?method=incisional&from_modal=eyes' 
    },
    { 
      id: 'sideeffects', 
      label: '수술 부작용', 
      path: '/eyes/side-effects?from_modal=eyes' 
    },
    { 
      id: 'lines', 
      label: '눈 라인의 종류', 
      path: '/eyes/lines?type=inline&from_modal=eyes'
    },
    { 
      id: 'types', 
      label: '눈의 종류', 
      path: '/eyes/types?from_modal=eyes' 
    },
  ];
  
  const handleItemClick = (item: ModalItem) => {
    if (item.path) {
      router.push(item.path);
      close(); 
      if (onClose) onClose(); 
    } else if (item.action) {
      item.action();
    }
  };
  
  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close();
          if (onClose) onClose();
        }}
        withCloseButton={false}
        centered
        radius={'lg'}
        padding={24}
        size='lg'
        closeOnClickOutside={true}
        classNames={{ 
        content: 'scrollbar-hide', 
        }}
      >
        <div className="flex flex-col gap-3 mb-5">
          <div className="text-lg text-gray-700 dark:text-gray-100 font-semibold" data-autofocus>
            눈 성형
          </div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 max-w-[560px] mx-auto">
          {items.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col items-center justify-center gap-3 border border-gray-200 dark:border-gray-700 p-4 text-center h-[76px] text-gray-700 text-[15px] font-normal hover:border-blue-700 hover:text-blue-700 dark:hover:text-blue-400 transition-colors cursor-pointer rounded-lg bg-white dark:bg-gray-800`}
              onClick={() => handleItemClick(item)}
            >
              <div className="text-[15px] font-normal"> 
                {item.label}
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex gap-1 justify-end mt-5">
          <Button 
            classNames={themeVariables.button.gray} 
            onClick={() => {
              close();
              if (onClose) onClose();
            }}
          >
            닫기
          </Button>
        </div>
      </Modal>
      
      <EyesLinesModal 
        forceOpened={showLinesModal} 
        onClose={() => {
          setShowLinesModal(false);
        }}
      />
    </>
  )
}